import app from 'flarum/forum/app';
import on from './gate';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import pollLearn, { building } from './pollLearn';
import BuildStatus from './BuildStatus';
import { day } from './index';
export default class ChallengeCard extends Component {
  stopPolling = () => {};
  oninit(v) {
    super.oninit(v);
    this.challenge = {
      ...this.attrs.challenge
    };
    if (on() && building(this.challenge.status)) this.stopPolling = pollLearn(this.challenge.slug, page => {
      Object.assign(this.challenge, {
        status: page.status,
        approved: page.approved,
        progress: page.progress,
        progress_at: page.progress_at
      });
    });
  }
  onremove() {
    this.stopPolling();
  }
  view() {
    if (!on()) return null;
    const c = this.challenge;
    const d = day(c.started_at);
    return m("section", {
      className: "Challenge-card"
    }, m("div", {
      className: "Challenge-recording"
    }, c.image_url && m("img", {
      src: c.image_url,
      alt: "Album cover"
    }), m("div", null, m("span", {
      className: "Challenge-pill"
    }, d > 30 ? 'Finished' : `Day ${d} of 30`), m("h2", null, c.track), m("p", null, c.artist, " \xB7 ", c.album, " (", c.year, ")"))), m("p", null, "Learning: ", c.parts.join(', ') || 'song', c.hard_part && m("span", null, " \xB7 Hardest part: ", c.hard_part)), c.status === 'ready' && c.approved ? m("a", {
      href: app.forum.attribute('baseUrl') + '/learn/' + c.slug
    }, "Your Learn page") : building(c.status) ? m(BuildStatus, {
      progress: c.progress
    }) : m("p", null, c.status === 'ready' ? 'Your Learn page is being checked.' : 'Your Learn page could not be built yet.', app.session.user?.isAdmin() && m("a", {
      className: "Challenge-reviewLink",
      href: app.forum.attribute('baseUrl') + '/learn/' + c.slug
    }, "Review Learn page \u2192")), m("footer", null, "Doing this too? ", m(Button, {
      className: "Button Button--link",
      onclick: async () => {
        if (!app.session.user) {
          app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'));
          return;
        }
        await app.tagList.load(['parent']);
        const tag = app.store.all('tags').find(t => t.slug() === 'challenges');
        await app.composer.load(() => flarum.reg.asyncModuleImport('flarum/forum/components/DiscussionComposer'), {
          user: app.session.user
        });
        app.composer.fields.tags = tag ? [tag] : [];
        app.composer.show();
        m.redraw();
      }
    }, "Start your own challenge")));
  }
}